import { ArticlesList } from "components/blog/articles-list";
import {
  ArrowRight,
  BookOpenText,
  Bot,
  CalendarSync,
  CodeXml,
  Database,
  Download,
  Map,
  SquareScissors,
  type LucideIcon,
} from "lucide-react";
import { useHistory } from "react-router-dom";
import * as Routes from "routes";
import { StandardPageLayout } from "components/layouts/standard-page-layout";
import {
  Card,
  CardAction,
  CardDescription,
  CardHeader,
  CardIcon,
  CardTitle,
} from "components/ui/card";
import { Button } from "components/ui/button";

export const HubPage = () => {
  return (
    <StandardPageLayout
      breadcrumbs={[]}
      pageTitle={{
        icon: Database,
        title: "Welcome to Geoscape Hub",
        description:
          "Your central hub for accessing, clipping, and integrating Geoscape data. Get started with quick actions below or explore the sidebar navigation.",
      }}
    >
      <ActionMenu />
      <WhatsNewPreview />
    </StandardPageLayout>
  );
};

const quickActions: {
  title: string;
  description: string;
  href: string;
  icon: LucideIcon;
  color: string;
}[] = [
  {
    title: "Explore",
    description:
      "Browse and visualize Geoscape datasets in our interactive data explorer",
    href: Routes.dataExplorer,
    icon: Map,
    color: "bg-chart-4",
  },
  {
    title: "Data Catalogue",
    description:
      "Explore avaliable datasets, their uses and applications in our data catalogue",
    href: Routes.dataExplorer,
    icon: Map,
    color: "bg-chart-5",
  },
  {
    title: "Clip",
    description: "Browes and clip Geoscape data to your areas of interest",
    href: Routes.clipUi,
    icon: SquareScissors,
    color: "bg-warning",
  },
  {
    title: "Download",
    description: "Download your licensed datasets and data products",
    href: Routes.dataDownload,
    icon: Download,
    color: "bg-info",
  },
  {
    title: "Batch",
    description: "Perfom batch geocoding and validation",
    href: Routes.batchBatches,
    icon: Bot,
    color: "bg-accent",
  },
  {
    title: "Apps & APIs",
    description:
      "Integrate geocoding, validation, and more into your applications",
    href: Routes.developerApiKeys,
    icon: CodeXml,
    color: "bg-chart-3",
  },
  {
    title: "Documentation",
    description: "Specifications, release notes, guides, and API reference",
    href: Routes.docsPage,
    icon: BookOpenText,
    color: "bg-chart-1",
  },
  {
    title: "Subscription",
    description: "Manage your Geoscape Hub subscription and billing details",
    href: Routes.orgSubscription,
    icon: CalendarSync,
    color: "bg-chart-2",
  },
];

const ActionMenu = () => {
  const history = useHistory();

  return (
    <section className="space-y-4">
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
      </CardHeader>
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        {quickActions.map((action) => (
          <Card
            key={action.title}
            className="group relative overflow-hidden  bg-card hover:bg-muted cursor-pointer"
            onClick={() => history.push(action.href)}
          >
            <CardHeader>
              <CardIcon
                variant="top"
                className={`${action.color} text-background p-2.5 rounded-lg`}
              >
                <action.icon className="size-5" />
              </CardIcon>
              <CardTitle>{action.title}</CardTitle>
              <CardDescription>{action.description}</CardDescription>
              <ArrowRight className="absolute bottom-4 right-4 size-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
            </CardHeader>
          </Card>
        ))}
      </div>
    </section>
  );
};

const WhatsNewPreview = () => {
  const history = useHistory();

  const handleArticleClick = (identifier: string) => {
    history.push(`/whats-new/${identifier}`);
  };

  return (
    <section className="space-y-4">
      <CardHeader className="gap-0">
        <CardTitle>What&apos;s New</CardTitle>
        <CardDescription className="truncate">
          Latest updates, releases, and announcements
        </CardDescription>
        <CardAction className="mt-auto">
          <Button
            className="hover:cursor-pointer"
            variant="ghost"
            size="sm"
            onClick={() => history.push(Routes.whatsNew)}
          >
            View all updates
            <ArrowRight className="size-4 ml-2" />
          </Button>
        </CardAction>
      </CardHeader>
      <ArticlesList limit={6} onArticleClick={handleArticleClick} />
    </section>
  );
};
